module.exports = __webpack_public_path__ + "static/media/web1.7fd6c2e9.jpg";